if (!customElements.get("ingredients-slider")) {
  class IngredientsSlider extends HTMLElement {
    constructor() {
      super();
      this.modal = null;
    }

    connectedCallback() {
      this.slider = this.querySelector(".ingredients__slider");
      this.nextBtn = this.querySelector(".ingredients__next-btn");
      this.prevBtn = this.querySelector(".ingredients__prev-btn");
      this.pagination = this.querySelector(".ingredients__pagination");

      this.addEventListener('click', ({ target }) => {
        const trigger = target.closest('[data-modal-target]');
        if (!trigger) return;

        const modalId = trigger.getAttribute('data-modal-target');
        this.openModal(modalId);
      });

      this.initSlider();
    }

    openModal(modalId) {
      this.modal = this.querySelector(`#${modalId}`);
      if (!this.modal) return;

      this.modal.showModal();
      this.scrollPosition = window.scrollY;
      this.bodyLock(true);

      const closeBtn = this.modal.querySelector('.modal-close-btn');
      if (closeBtn) {
        closeBtn.addEventListener('click', () => this.closeModal(), { once: true });
      }

      this.modal.addEventListener('click', (e) => {
        if (e.target === this.modal) this.closeModal();
      }, { once: true });

      const escHandler = (e) => {
        if (e.key === "Escape") this.closeModal();
      };
      document.addEventListener('keydown', escHandler, { once: true });

      this._escHandler = escHandler;
    }

    closeModal() {
      if (!this.modal) return;

      this.modal.close();
      this.bodyLock(false);

      if (this._escHandler) {
        document.removeEventListener('keydown', this._escHandler);
        this._escHandler = null;
      }

      this.modal = null;
    }

    bodyLock(value) {
      const body = document.body;

      if (value) {
        body.style.top = `-${this.scrollPosition}px`;
        body.style.overflow = "hidden";
        body.style.position = "fixed";
        body.style.width = "100%";
        return;
      }

      body.style.removeProperty("overflow");
      body.style.removeProperty("position");
      body.style.removeProperty("width");
      body.style.removeProperty("top");

      window.scrollTo(0, this.scrollPosition);
    }

    initSlider() {
      if (!this.slider) return;

      const autoplayDelay = parseInt(this.slider.dataset.autoplayDelay);

      const swiperOptions = {
        slidesPerView: 1,
        spaceBetween: 10,
        loop: true,
        grabCursor: true,
        speed: 400,
        navigation: {
          nextEl: this.nextBtn,
          prevEl: this.prevBtn,
        },
        pagination: {
          el: this.pagination,
          clickable: true,
        },
        breakpoints: {
          1023: { slidesPerView: 1.8 },
          1500: { slidesPerView: 2.8 },
        }
      };

      if (autoplayDelay && autoplayDelay > 0) {
        swiperOptions.autoplay = {
          delay: autoplayDelay * 1000,
          disableOnInteraction: false,
        };
      }

      new Swiper(this.slider, swiperOptions);
    }
  }

  customElements.define("ingredients-slider", IngredientsSlider);
}
